import { render, staticRenderFns } from "./ContentCollectionManager.vue?vue&type=template&id=1de7a73e&scoped=true&"
import script from "./ContentCollectionManager.vue?vue&type=script&lang=js&"
export * from "./ContentCollectionManager.vue?vue&type=script&lang=js&"
import style0 from "./ContentCollectionManager.vue?vue&type=style&index=0&id=1de7a73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de7a73e",
  null
  
)

export default component.exports